const serveuse_route = [
  {
    path: '/serveUse',
    name: "serveUse",
    component: resolve => {
      require(["@/views/manage/serveUse/Index.vue"], resolve);
    },
    redirect: { path: "/serveUse/serveUselist" },
    meta: {
      title: '服务使用者管理',
      navtype: 1,
      active: ['/serveUse/serveUselist','/serveUse/serveUseChecklist']
    },
    children: [
      {
        path: 'serveUselist',
        name: "serveUseList",
        component: resolve => {
          require(["@/views/manage/serveUse/serveUser/ServeList.vue"], resolve);
        },
        meta: {
          public: false,
          title: '服务使用者管理',
          navtype: 1,
          id:[10031],
          active: ['/serveUse/serveUselist','/serveUse/serveUseChecklist']
        }
      },
      {
        path: 'ServeUseDetail',
        name: "ServeUseDetail",
        component: resolve => {
          require(["@/views/manage/serveUse/serveUser/ServeUseDetail.vue"], resolve);
        },
        meta: {
          title: '服务使用者管理详情',
          navtype: 1,
          id:[10032],
          active: ['/serveUse/serveUselist','/serveUse/serveUseChecklist']
        }
      },
      {
        path: 'serveUseAppIndex',
        name: "serveUseAppIndex",
        component: resolve => {
          require(["@/views/manage/serveUse/serveUser/AppIndex.vue"], resolve);
        },
        redirect: { path: "/serveUse/serveUseAppList" },
        meta: {
          title: '应用列表',
          navtype: 1,
          active: ['/serveUse/serveUselist','/serveUse/serveUseChecklist']
        },
        children: [
          {
            path: '/serveUse/serveUseAppList',
            name: "serveUseAppList",
            component: resolve => {
              require(["@/views/manage/serveUse/serveUser/AppList.vue"], resolve);
            },
            meta: {
              navtype: 1,
              id:[10061],
              active: ['/serveUse/serveUselist','/serveUse/serveUseChecklist']
            }
          },
          {
            path: '/serveUse/serveUseAppDetail',
            name: "serveUseAppDetail",
            component: resolve => {
              require(["@/views/manage/serveUse/serveUser/AppDetail.vue"], resolve);
            },
            meta: {
              title: '应用详情',
              navtype: 1,
              id:[10062],
              active: ['/serveUse/serveUselist','/serveUse/serveUseChecklist']
            }
          },
        ],
      },
      {
        path: 'serveUseChecklist',
        name: "serveUseChecklist",
        component: resolve => {
          require(["@/views/manage/serveUse/serveUserCheck/ServeUseCheckList.vue"], resolve);
        },
        meta: {
          title: '服务使用者审核',
          navtype: 1,
          id:[10033],
          active: ['/serveUse/serveUselist','/serveUse/serveUseChecklist']
        }
      },
      {
        path: 'serveUseCheckDetail',
        name: "serveUseCheckDetail",
        component: resolve => {
          require(["@/views/manage/serveUse/serveUserCheck/ServeUseCheckDetail.vue"], resolve);
        },
        meta: {
          title: '服务使用者审核详情',
          navtype: 1,
          id:[10034,10035],
          active: ['/serveUse/serveUselist','/serveUse/serveUseChecklist']
        }
      },
    ]
  },
];
export default serveuse_route